import { render, staticRenderFns } from "./tabZujian.vue?vue&type=template&id=0f63bc9e&scoped=true&"
import script from "./tabZujian.vue?vue&type=script&lang=js&"
export * from "./tabZujian.vue?vue&type=script&lang=js&"
import style0 from "./tabZujian.vue?vue&type=style&index=0&id=0f63bc9e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f63bc9e",
  null
  
)

export default component.exports